import { Component, ChangeDetectorRef } from "@angular/core";
import { ShippingMethodItem } from "../../interfaces/interfaces";
import { ApiService } from '../../services/api.service';
import { DialogService } from 'primeng/dynamicdialog';
import { SimpleTableComponent } from "../../generals/Components";
import { ShippingMethodEditorComponent } from "../shippingmethodeditor/shippingmethodeditor.component";
import { filter } from "rxjs/operators";

@Component({
    selector: 'app-shippingmethods',
    templateUrl: './shippingmethods.component.html'
})
export class ShippingMethodsComponent extends SimpleTableComponent<ShippingMethodItem> {
    constructor(
      private apiServiceRef: ApiService,
      private dialogService: DialogService,
      private changeDetectionRef: ChangeDetectorRef
    ) {
      super(changeDetectionRef, apiServiceRef);
      this.endPoint = 'shippingmethods';
    }
    showShippingMethodEditorModal(shippingMethodItem: ShippingMethodItem): void {
      this.dialogService.open(ShippingMethodEditorComponent, {
        header: 'Szállítási mód szerkesztése',
        data: {
          id: shippingMethodItem.id
        }
      }).onClose.pipe(filter((rsp) => rsp !== undefined && rsp === true)).subscribe(() => {
        this.refreshTable();
      });
    }
}
